import { ROUTES } from '../constants/routes';

const MEETING_WIZARD_EDIT_RE = /^\/meetings\/[^/]+\/edit$/;

/** آیا مسیر فعلی ویزارد ایجاد/ویرایش جلسه است؟ */
export function isMeetingWizardPath(pathname) {
  if (!pathname) return false;
  return pathname === ROUTES.MEETINGS_NEW || MEETING_WIZARD_EDIT_RE.test(pathname);
}

/**
 * خروج اجباری از ویزارد جلسه با بارگذاری کامل صفحه.
 * RR7 گاهی URL را عوض می‌کند ولی Outlet همان کامپوننت قبلی را نگه می‌دارد.
 */
export function hardNavigateFromMeetingWizard(targetPath) {
  const path = typeof targetPath === 'string' && targetPath.startsWith('/') ? targetPath : ROUTES.MEETINGS;
  if (isMeetingWizardPath(window.location.pathname)) {
    window.location.assign(path);
    return true;
  }
  return false;
}
